import type { User } from "src/api/types/user";
import { API_BASE_URL } from "src/apiServices/apiConfig";
import axios from "axios";

// const STORAGE_KEY: string = 'users';
// const ACCESS_TOKEN_KEY = 'accesToken';
// const REFRESH_TOKEN_KEY = 'refresToken'

// NOTE: We use sessionStorage since memory storage is lost after page reload.
//  This should be replaced with a server call that returns DB persisted data.

// const getPersistedUsers = (): User[] => {
//   try {
//     const data = sessionStorage.getItem(ACCESS_TOKEN_KEY);

//     if (!data) {
//       return [];
//     }

//     return JSON.parse(data) as User[];
//   } catch (err) {
//     console.error(err);
//     return [];
//   }
// };

// const persistUser = (user: User): void => {
//   try {
//     const users = getPersistedUsers();
//     const data = JSON.stringify([...users, user]);
//     sessionStorage.setItem(ACCESS_TOKEN_KEY, data);
//   } catch (err) {
//     console.error(err);
//   }
// };

type SignInRequest = {
  email: string;
  client_secret: string;
};

type AuthReponse = {
  status: boolean;
  code: number;
  message: string;
  data?: any;
  tokens?: {
    access: { token: string; expires: string };
    refresh: { token: string; expires: string };
  };
};

type SignUpRequest = {
  email: string;
  name: string;
  client_secret: string;
};

type SignUpResponse = {
  status: boolean;
  code: number;
  message: string;
  data?: any;
  token?: {
    access: { token: string; expires: string };
    refresh: { token: string; expires: string };
  };
};

class AuthApi {
  async signIn(request: SignInRequest): Promise<AuthReponse> {
    try {
      const response = await axios.post<AuthReponse>(
        `${API_BASE_URL}/auth/login`,
        request,
        {
          withCredentials: true,
        }
      );

      if (response.data.status && response.data.tokens) {
        // this.storeTokens(response.data.tokens)

        return response.data;
      }

      return response.data;
    } catch (error: any) {
      console.error("Login Failed: ", error);
      throw error.response?.data || { message: "Invalid email or password" };
    }
  }

  async signUp(request: SignUpRequest): Promise<SignUpResponse> {
    try {
      const response = await axios.post<AuthReponse>(
        `${API_BASE_URL}/auth/register`,
        request,
        {
          withCredentials: true,
        }
      );

      // if(response.data.status && response.data.tokens){
      //   this.storeTokens(response.data.tokens)
      // }

      return response.data;
    } catch (error: any) {
      console.error("Registration failed: ", error);
      throw (
        error.response?.data || {
          message: "Registration failed. Please try again.",
        }
      );
    }
  }

  async logout(): Promise<void> {
    try {
      await axios.post(
        `${API_BASE_URL}/logout`,
        {},
        {
          withCredentials: true,
        }
      );
    } catch (error) {
      console.error("Logout failed", error);
    }
  }

  async refreshToken(): Promise<void> {
    try {
      await axios.post(
        `${API_BASE_URL}/refreshTokens`,
        {},
        {
          withCredentials: true,
        }
      );
    } catch (error) {
      console.error("Token refresh failed", error);
    }
  }

  async changePassword(
    oldPassword: string,
    newPassword: string,
    confirmPassword: string
  ): Promise<void> {
    try {
      await axios.post(
        `${API_BASE_URL}/changePassword`,
        {
          old_password: oldPassword,
          password: newPassword,
          confirm_password: confirmPassword,
        },
        { withCredentials: true }
      );
    } catch (error) {
      console.error("Password change failed:", error);
      throw error.response?.data || { message: "Failed to change password" };
    }
  }

  async me(): Promise<User> {
    try {
      // const response = await axios.get<User>(`${API_BASE_URL}/client/me`, {
      //   withCredentials: true,
      // });
      // return response.data;
      throw new Error("Not implemented");
    } catch (error) {
      console.error("Failed to fetch user:", error);
      throw error.response?.data || { message: " Failed to fetch user" };
    }
  }

  // ✅ Store tokens securely
  // private storeTokens(tokens: { access: { token: string }; refresh: { token: string } }) {
  //   Cookies.set(ACCESS_TOKEN_KEY, tokens.access.token, {secure:true});
  //   Cookies.set(REFRESH_TOKEN_KEY, tokens.refresh.token, {secure:true,});
  // }

  // // Get access token
  // private getAccessToken(): string | undefined {
  //   return Cookies.get(ACCESS_TOKEN_KEY);
  // }

  // // Get refresh token
  // private getRefreshToken(): string | undefined {
  //   return Cookies.get(REFRESH_TOKEN_KEY);
  // }

  // // Clear tokens
  // private clearTokens() {
  //   Cookies.remove(ACCESS_TOKEN_KEY);
  //   Cookies.remove(REFRESH_TOKEN_KEY);
  // }
}

export const authApi = new AuthApi();
